import { startTransition } from 'react';

import { ODTeamBoundary } from 'platform/ODTeamBoundary';
import { installReadOnlyNetworkGuard } from 'platform/readOnlyNetwork';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import 'preloadQueries';

// Before hydration so no request can slip out ahead of the guard.
installReadOnlyNetworkGuard();

// Chosen from the upper p75 first-client-query window, before the p95 tail.
const HYDRATE_IDLE_TIMEOUT_MS = 1500;

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      document,
      <ODTeamBoundary>
        <HydratedRouter />
      </ODTeamBoundary>,
    );
  });
};

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(hydrate, { timeout: HYDRATE_IDLE_TIMEOUT_MS });
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}
